// extracted by mini-css-extract-plugin
module.exports = {"dividerColor":"rgba(0,168,164,0.26)"};